<template>
    <div>
        <div class="form-group">
            <label for="modelNamespace">{{$t('text.modelEntry.namespace')}}</label>
            <input type="text" class="form-control mw-100" id="modelNamespace"
                   aria-describedby="modelNamespace"
                   name="modelNamespace"
                   v-model="property.namespaceUri"
            >
        </div>

        <div class="form-group">
            <label for="modelNamespacePrefix">{{$t('text.modelEntry.displayLabel')}}</label>
            <input type="text" class="form-control mw-100" id="modelNamespacePrefix"
                   aria-describedby="modelNamespacePrefix"
                   name="modelNamespacePrefix"
                   v-model="property.namespacePrefix"
            >
        </div>

        <div class="form-group">
            <label for="modelName">{{$t('text.modelEntry.name')}}</label>
            <input type="text" class="form-control mw-100" id="modelName"
                   aria-describedby="modelName"
                   name="modelName"
                   v-model="property.name"
            >
        </div>

        <div class="form-group">
            <label for="modelDescription">{{$t('text.modelEntry.description')}}</label>
            <textarea class="form-control" id="modelDescription" aria-describedby="modelDescription"
                      name="modelDescription"
                      v-model="property.description"
            ></textarea>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModalEntry",

        props: {
            editMode: Boolean,
            model: Object,
        },
        data() {
            return {
                property: {
                    name: null,
                    author: null,
                    namespacePrefix: null,
                    namespaceUri: null,
                    status: null,
                    description: null,

                },
            }
        },

        mounted() {
            console.log("mounted");
            if(this.editMode === false) {
                this.$root.$on("createNewModel", () => {
                    this.$root.$emit("setNewModel", this.property);
                    this.property = {
                        name: null,
                        author: null,
                        namespacePrefix: null,
                        namespaceUri: null,
                        status: null,
                        description: null,
                    };
                });

            }



            else {
                this.property = _.cloneDeep(this.model);
                console.log("setEditModel on");
                this.$root.$on("editModel", (model) => {
                    console.log("editModel", model);
                    this.property = _.cloneDeep(model);
                    console.log(this.property);
                });


                this.$root.$on("setEditedModel", () => {
                    this.$root.$emit("updateModel", this.property);
                });
            }
        },


        beforeDestroy() {
            this.$root.$off("createNewModel");
            this.$root.$off("editModel");
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ModelEntry.vue